interface Params {
  keysToKeep?: string[];
  partOfKeyToKeep?: string;
}

export function clearLocalStorageExceptSomeKeys({ keysToKeep = [], partOfKeyToKeep }: Params = {}): void {
  const savedValues: Record<string, string> = {};

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key) continue;

    const shouldKeep =
      keysToKeep.includes(key) ||
      (partOfKeyToKeep && key.includes(partOfKeyToKeep));

    if (shouldKeep) {
      const value = localStorage.getItem(key);
      if (value !== null) {
        savedValues[key] = value;
      }
    }
  }

  localStorage.clear();

  Object.entries(savedValues).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
}